import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { DateTime } from 'luxon';
import { DiagnosticEventDTO, FreezeFrameMeasurementDetailDTO } from 'src/app/base/models/models.swagger.generated';

@Component({
  selector: 'app-diagnostic-event-detail-dialog',
  templateUrl: './diagnostic-event-detail-dialog.component.html',
  styleUrls: ['./diagnostic-event-detail-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DialogModule, TranslatePipe],
})
export class DiagnosticEventDetailDialogComponent {

  @Input() event: DiagnosticEventDTO | null = null;
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  public close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  public formatDateTime(dt: DateTime | undefined): string {
    return dt ? dt.toFormat('dd.MM.yyyy HH:mm') : '—';
  }

  public formatEcuId(ecuId: number | undefined): string {
    return ecuId == null ? '—' : ecuId.toString();
  }

  public formattedValueJson(json: string | undefined): string {
    if (!json) {
      return '—';
    }
    try {
      return JSON.stringify(JSON.parse(json), null, 2);
    } catch {
      return json;
    }
  }

  public signalLabel(measurement: FreezeFrameMeasurementDetailDTO): string {
    return measurement.signalName ?? `#${measurement.signalId}`;
  }
}
